module.exports =
  '_GROUP_TIMELINE':
    'TITLE': 'Timeline'
    'CREATE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を作成しました。'
    'UPDATE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を更新しました。'
    'DELETE_EVENT_TITLE': '{{name}}さんが、イベント「{{event}}」を削除しました。'
    'SUBMIT_SCORE_TITLE': '{{name}}さんが、「{{event}}」にスコアを提出しました。'
    'SUBMIT_SCORES_TITLE': '{{name}}さんが、イベント 「{{event}}」に {{score_cards_count}} 件のスコアを提出しました。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/i18n/ja.coffee